import { Box, Typography, useTheme } from "@mui/material";
import { darken } from "@mui/system";
import useStyles from "./styles";
import { useRef } from "react";

const LegendsCharts = (props) => {
  const {
    keys,
    colors,
    position = "left",
    direction = "row",
    variant = "default",
    legendSpacing = 2,
    metricsType,
  } = props;
  const theme = useTheme();
  const boxRef = useRef();
  const metricsData = metricsType;

  const numItems =
    metricsData &&
    metricsData.length > 0 &&
    metricsData?.[0] &&
    typeof metricsData?.[0] === "object"
      ? Object.keys(metricsData?.[0]).length
      : keys?.length || 0;
  const data = keys;
  const legendColors = colors;

  const legendStyles = useStyles(theme, metricsData || {});

  return (
    <Box
      sx={legendStyles.contentSx(direction, position, legendSpacing)}
      ref={boxRef}
    >
      {metricsData && metricsData.length > 0
        ? metricsData.map(({ key, label, value }, index) => (
            <Box key={index} sx={legendStyles.contentChildSx(variant)}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  ...(variant === "block" ? { width: "100%" } : {}),
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row",
                    gap: 1,
                    alignItems: "center",
                    justifyContent: "start",
                    ...(variant === "block" ? { width: "100%" } : {}),
                  }}
                >
                  <Box
                    sx={[
                      legendStyles.symbolSx(legendColors),
                      {
                        border: `1px solid ${darken(legendColors, 0.2)}`,
                      },
                    ]}
                  />
                  <Typography
                    fontSize={{ xs: "clamp(14px, 30cqh, 22px)" }}
                    fontWeight={500}
                    color="text.secondary"
                    sx={variant === "block" ? legendStyles.textTypography : {}}
                    lineHeight={"100%"}
                  >
                    {label ?? key}
                  </Typography>
                </Box>
                <Typography
                  fontSize={
                    variant === "block"
                      ? { xs: "clamp(17px, 40cqh, 24x)" }
                      : { xs: "clamp(17px, 40cqh, 24px)" }
                  }
                  fontWeight={500}
                  color="text.primary"
                  sx={variant === "block" ? legendStyles.textTypography : {}}
                >
                  {value}
                </Typography>
              </Box>
            </Box>
          ))
        : data?.map((item, index) => {
            return (
              <Box key={index} sx={legendStyles.contentChildSx(variant)}>
                <Box
                  sx={[
                    legendStyles.symbolSx(legendColors[index]),
                    {
                      border: `1px solid ${darken(
                        legendColors[index] || "#000",
                        0.2,
                      )}`,
                    },
                  ]}
                />
                <Typography sx={legendStyles.textSx}>{String(item)}</Typography>
              </Box>
            );
          })}
    </Box>
  );
};

export default LegendsCharts;
